export interface DecorativeCirclesProps {
  /**
   * Optional additional CSS classes for positioning and sizing the container.
   */
  className?: string;
}

/**
 * Renders a set of five nested decorative circles based on the landing page design.
 */
export const DecorativeCircles: React.FC<DecorativeCirclesProps> = ({ className }) => {
  return (
    <div className={`pointer-events-none aspect-[776/695] ${className || ''}`}>
      <svg width="100%" height="100%" viewBox="0 0 776 695" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.2" cx="388.079" cy="388.079" r="286.079" stroke="#FFD381" strokeWidth="2" />
        <path
          opacity="0.2"
          d="M270.589 692.658C206.935 668.127 152.563 624.274 115.11 567.258C77.657 510.242 59.0032 442.926 61.7683 374.765C64.5335 306.604 88.5789 241.021 130.528 187.226C172.476 133.431 230.221 94.1265 295.653 74.8319C361.084 55.5374 430.916 57.2221 495.341 79.6495C559.767 102.077 615.549 144.12 654.855 199.876C694.16 255.631 715.015 322.297 714.49 390.512C713.965 458.728 692.087 525.065 651.928 580.209"
          stroke="#C8C2FF"
          strokeWidth="3"
        />
        <path
          opacity="0.3"
          d="M92.764 638.209C43.2773 579.817 12.2172 508.062 3.51139 432.017C-5.19438 355.972 8.84522 279.054 43.8548 210.988C78.8644 142.923 133.271 86.7676 200.196 49.6235C267.121 12.4794 343.557 -3.98518 419.839 2.31191C496.121 8.609 568.822 37.3849 628.75 85.0007C688.677 132.616 733.139 196.934 756.513 269.819C779.888 342.704 781.124 420.883 760.066 494.471C739.008 568.059 696.601 633.749 638.209 683.236"
          stroke="#FFDFD4"
          strokeWidth="2"
        />
        <path
          opacity="0.3"
          d="M592.322 307.528C604.516 338.845 609.367 372.541 606.501 406.026C603.635 439.512 593.129 471.894 575.79 500.683C558.451 529.472 534.741 553.902 506.483 572.095C478.226 590.287 446.172 601.757 412.788 605.624C379.404 609.49 345.577 605.65 313.909 594.397C282.242 583.145 253.576 564.781 230.115 540.717C206.655 516.653 189.026 487.529 178.582 455.586C168.139 423.642 165.159 389.729 169.873 356.454"
          stroke="#FFD79A"
          strokeWidth="4"
        />
        <circle opacity="0.3" cx="387.57" cy="387.57" r="197.57" stroke="#A7E9FF" strokeWidth="4" />
      </svg>
    </div>
  );
};
